(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('PendingUserController', PendingUserController);

    /* @ngInject */
    function PendingUserController(logger, pendingUserService, $uibModal,
        userOnBoardingService, roleService, $scope, userService, $state,
        utilitiesService, ATAC) {
        var vm = this;
        var onBoardOptions = userOnBoardingService.getModalOptions();

        vm.pendingUsers = [];
        vm.processedUsers = [];

        vm.getPendingUsers = pendingUserService.getPendingUsers;
        vm.getProcessedUsers = pendingUserService.getProcessedUsers;
        vm.getRejectedCustomers = pendingUserService.getRejectedCustomers;

        // Smart Table
        vm.pendingUsersTableConfig = configureTableActions(true);
        vm.processedUsersTableConfig = configureTableActions(false);
        vm.rejectedCustomerTableConfig = configureRejectedTableActions();

        //Activate Controller
        activate();

        function activate() {
            logger.info('Activated Pending Users Dashboard View');
            updatePendingUsersCount();
        }

        function configureTableActions(isPendingTable) {
            var tableConfig = (isPendingTable) ? pendingUserService.getPendingUsersTableConfig() :
                pendingUserService.getProcessedUsersTableConfig();

            if (isPendingTable) {
                tableConfig.actions = [
                    {
                        name: '"Review"',
                        action: onBoardUser,
                        icon: '"fa-check"',
                        permission: 'AUTHORIZED'
                    },
                    {
                        name: '"Reject with Email"',
                        action: rejectWithEmail,
                        icon: '"fa-envelope"',
                        permission: 'AUTHORIZED'
                    }];
            }
            return tableConfig;
        }

        function configureRejectedTableActions() {
            var tableConfig = pendingUserService.getPendingUsersTableConfig();

            tableConfig.actions = [
                {
                    name: '"Reject with Email"',
                    action: rejectWithEmail,
                    icon: '"fa-envelope"',
                    permission: 'AUTHORIZED'
                }];
            return tableConfig;
        }

        function rejectWithEmail(pendingUser) {
            pendingUserService.rejectPendingUser(pendingUser.PendingUserId)
                .then(function (result) {
                    pendingUser.Rejected = result.data.Rejected;
                    pendingUser.Processed = result.data.Processed;

                    // set Master record to inactive
                    if (pendingUser.UserId !== null) {
                        userService.getUser(pendingUser.UserId).then(function (user) {
                            if (user !== null) {
                                user.IsActive = false;
                                userService.setActive(user).then(function (response) {
                                    logger.info('Master User has been set to inactive');
                                });
                            }
                        });
                    }

                    moveToProcessed(pendingUser);
                    logger.info('Reject Email has been sent');
                });
        }

        function onBoardUser(pendingUser) {
            ATAC.showLoader();

            if (pendingUser.SiteStatusId === 3) {
                logger.error('This Pending User has an address that has been rejected.');
                ATAC.hideLoader();
                return;
            }

            if (pendingUser.SiteStatusId === 1) {
                logger.error('This Pending User has an address still in pending status.');
                ATAC.hideLoader();
                return;
            }

            userService.searchEmail(pendingUser.Email).then(function (results) {
                var userCanBeOnboarded = !results.data || (results.data && !!pendingUser.UserId);

                if (userCanBeOnboarded) {
                    $state.go('user.pendingEdit', { pendingId: pendingUser.PendingUserId });
                } else {
                    logger.error('This user already exists');
                    ATAC.hideLoader();
                    return;
                }
            });
        }

        function processPendingUser(pendingUser) {
            return pendingUserService.processPendingUser(pendingUser).then(function (result) {
                if (result.status === 200) {
                    pendingUser = result.data;
                } else {
                    logger.info('issue saving pending user');
                }
            });
        }

        function moveToProcessed(pendingUser) {
            var pendingUserIndex = utilitiesService.getIndexOf(vm.pendingUsers,
                'PendingUserId', pendingUser.PendingUserId);
            if (pendingUserIndex !== -1) {
                vm.pendingUsers.splice(pendingUserIndex, 1);
            }
            vm.processedUsers.push(pendingUser);
            updatePendingUsersCount();
        }

        function updatePendingUsersCount() {
            pendingUserService.getPendingUsersCount()
                .then(function (result) {
                    vm.pendingUsersCount = result.PendingUsersCount;
                    vm.pendingRejectedCustomerCount = result.RejectedCustomersCount;
                });
        }
    }
})();
